import React, { FC } from 'react'
import styled from 'styled-components'
import Image, { ImageProps } from '../image/Image'
import { Typography as Text } from '../typography/Typography'
import iconChristening from '../../assets/icons/icon-christening.svg'
import iconContact from '../../assets/icons/icon-contact.svg'
import iconCorporateInformation from '../../assets/icons/icon-corporate-information.svg'
import iconMediaResources from '../../assets/icons/icon-media-resources.svg'
import iconOceanCay from '../../assets/icons/icon-ocean-cay.svg'
import iconSustainability from '../../assets/icons/icon-sustainability.svg'
import iconTextLinkHover from '../../assets/icons/icon-text-link-hover.svg'
import iconTextExternalLinkHover from '../../assets/icons/icon-text-link-external-hover.svg'
import Spacing from '../spacing/Spacing'
import TextLink, { Icon } from '../text-link/TextLink'
import { Link } from 'gatsby'

const icons = {
	boat: iconChristening,
	telephone: iconContact,
	'msc logo': iconCorporateInformation,
	note: iconMediaResources,
	shell: iconOceanCay,
	recycle: iconSustainability,
}

export interface NavigationCardProps {
	imageProps: ImageProps
	title: string
	description: string
	icon: keyof typeof icons
	href?: string
}

export const TextWrapper = styled.div`
	position: relative;
	padding: 40px 32px;
	background-color: ${(props) => props.theme.accents.background};
	flex: 1;
`

export const NavigationIcon = styled.img`
	position: absolute;
	top: -27.5px;
	left: 32px;
`

export const NavigationCardStyled = styled(Link)<{ $externalUrl?: boolean }>`
	display: flex;
	height: 100%;
	flex-direction: column;

	&:hover ${Icon} {
		opacity: 1;
		${({ $externalUrl }) =>
			$externalUrl
				? 'background: url(' + iconTextExternalLinkHover + ');'
				: 'background: url(' + iconTextLinkHover + ');'}
	}
`

const NavigationCard: FC<NavigationCardProps> = ({
	imageProps,
	title,
	description,
	href = '#',
	icon,
}) => {
	return (
		<NavigationCardStyled to={href} $externalUrl={false}>
			<Image {...imageProps} />
			<TextWrapper>
				<NavigationIcon src={icons[icon]} />
				<Title variant="sectionHeading" accent="navyBlue">
					{title}
				</Title>
				<Spacing height={16} />
				<TextLink
					text={{ variant: 'paragraph' }}
					icon="showOnHoverOnly"
					// render as button
					onClick={() => {}}
				>
					{description}
				</TextLink>
			</TextWrapper>
		</NavigationCardStyled>
	)
}

const Title = styled(Text)`
	word-break: break-word;
`

export default NavigationCard
